import { render, staticRenderFns } from "./CalendarioVendaCombo.vue?vue&type=template&id=a536ff62&scoped=true"
import script from "./CalendarioVendaCombo.vue?vue&type=script&lang=js"
export * from "./CalendarioVendaCombo.vue?vue&type=script&lang=js"
import style0 from "./CalendarioVendaCombo.vue?vue&type=style&index=0&id=a536ff62&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a536ff62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a536ff62')) {
      api.createRecord('a536ff62', component.options)
    } else {
      api.reload('a536ff62', component.options)
    }
    module.hot.accept("./CalendarioVendaCombo.vue?vue&type=template&id=a536ff62&scoped=true", function () {
      api.rerender('a536ff62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/CalendarioVendaCombo.vue"
export default component.exports